'use strict';

exports.__esModule = true;
exports['default'] = componentWillMount;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentWillMount(value) {
  return (0, _property2['default'])('componentWillMount', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentWillMount.js
// module id = 580
// module chunks = 1